import React from "react";

interface IProps {
	img: string;
	displayName: string;
	jobTitle: string;
	department: string;
	linkedIn: string;
	email: string;
}

const AnalaystCard = ({ img, displayName, jobTitle, department, linkedIn, email }: IProps) => {
	return (
		<div className="card bg-transparent shadow-none m-0 h-100 w-100" style={{ height: 150 }}>
			<div className="card-body p-0">
				<div className="d-flex align-items-center">
					<div className="flex-shrink-0 align-self-center">
						<span className="mr-3">
							<img src={img} style={{ maxHeight: 150 }} alt={displayName + " image"} className="border-none rounded img-fluid" />
						</span>
					</div>
					<div className="flex-grow-1 align-self-center">
						<div className="mt-1 mb-1 fs-4 fw-500 text-snow">{displayName}</div>
						<p className="fs-5 nowrap text-light pb-0">{jobTitle}</p>
						<p className="fs-5 nowrap text-light">{department}</p>
						<div className="d-flex align-items-center">
							<a className="fs-5" href={linkedIn}>
								<i className="mdi mdi-linkedin mdi-24px mr-1"></i>
							</a>
							<a className="fs-5" href={email}>
								<i className="mdi mdi-email mdi-24px mr-1"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AnalaystCard;
